export const MENUITEMS_PLANNER = [
{
        label: 'planning',
        icon: 'pi pi-fw pi-star',
        items: [
          { label: 'order-list', icon: 'pi pi-fw pi-shopping-cart', routerLink: ['/planning/orders'], right: 'admin.planning-orders.list' },
          { label: 'clearing-list', icon: 'pi pi-fw pi-flag', routerLink: ['/planning/clearings'], right: 'admin.planning-orders.list-clearing' },
          { label: 'resources-list', icon: 'pi pi-fw pi-calendar', routerLink: ['/planning/resources-list'], right: 'admin.planning-orders.resources-list' },
        ],
      },
      {
        label: 'reportings',
        icon: 'pi pi-fw pi-chart-bar',
        items: [
          { label: 'orderplanning', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/reportings/orderplanning'], right: 'admin.reportings.orderplanning' },
          { label: 'acroles', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/reportings/acroles'], right: 'admin.reportings.acroles' },
          { label: 'rolestatistics', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/reportings/rolestatistics'], right: 'admin.reportings.rolestatistics' },
          { label: 'observerlist', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/reportings/observerlist'], right: 'admin.reportings.observerlist' },
          { label: 'observerappointments', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/reportings/observerappointments'], right: 'admin.reportings.observerappointments' },
          { label: 'toolbox', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/reportings/toolbox'], right: 'admin.reportings.toolbox' },
        ],
      },
      {
        label: 'basedata',
        icon: 'pi pi-fw pi-star',
        items: [
          { label: 'templates', icon: 'pi pi-fw pi-clone', routerLink: ['/templates'], right: 'admin.template.list' },
          { label: 'settings-templates', icon: 'pi pi-fw pi-sliders-h', routerLink: ['/planning/settings-templates'], right: 'admin.planning-settings.show-settings' },
          { label: 'settings-units', icon: 'pi pi-fw pi-sliders-h', routerLink: ['/planning/settings-units'], right: 'admin.planning-settings.show-settings' },
          { label: 'exercises', icon: 'pi pi-fw pi-briefcase', routerLink: ['/exercises'], right: 'admin.exercise.list' },
          { label: 'competences', icon: 'pi pi-fw pi-palette', routerLink: ['/competences'], right: 'admin.competence.list' },
          { label: 'ratingtypes', icon: 'pi pi-fw pi-thumbs-up', routerLink: ['/ratingtypes'], right: 'admin.ratingtype.list' },
          { label: 'recommendations', icon: 'pi pi-fw pi-compass', routerLink: ['/recommendations'], right: 'admin.recommendation.list' },
          { label: 'languages', icon: 'pi pi-fw pi-comments', routerLink: ['/languages'], right: 'admin.language.list' },
          { label: 'businessunits', icon: 'pi pi-fw pi-sitemap', routerLink: ['/businessunits'], right: 'admin.businessunit.list' },
          { label: 'locations', icon: 'pi pi-fw pi-map-marker', routerLink: ['/locations'], right: 'admin.location.list' },
          { label: 'rooms', icon: 'pi pi-fw pi-building', routerLink: ['/rooms'], right: 'admin.room.list' },
          { label: 'appointments', icon: 'pi pi-fw pi-calendar', routerLink: ['/appointments'], right: 'admin.appointments.edit' },
          { label: 'customers', icon: 'pi pi-fw pi-id-card', routerLink: ['/customers'], feature: 'customers', right: 'admin.customer.list' },
        ],
      },
      {
      label: 'statistics',
      icon: 'pi pi-fw pi-chart-bar',
      items: [{ label: 'competences', icon: 'pi pi-fw pi-palette', routerLink: ['/statistics/acs/competences'], right: 'admin.statistics.competences' }],
    },
{
      label: 'contents',
      icon: 'pi pi-fw pi-star',
      items: [
        { label: 'texttemplates', icon: 'pi pi-fw pi-align-left', routerLink: ['/contents/texttemplates'], right: 'admin.texttemplate.list' },
        { label: 'textblocks', icon: 'pi pi-fw pi-list', routerLink: ['/contents/textblocks'], right: 'admin.textblock.list' },
        { label: 'documents', icon: 'pi pi-fw pi-copy', routerLink: ['/contents/documents'], right: 'admin.document.list' },
        { label: 'reporttemplates', icon: 'pi pi-fw pi-microchip-ai', routerLink: ['/contents/reporttemplates'], right: 'admin.reporttemplate.list' },
        // { label: 'sentmessages', icon: 'pi pi-fw pi-envelope', routerLink: ['/contents/sentmessages'], right: 'admin.sentmessage.list' },
      ],
    },
{
      label: 'administration',
      icon: 'pi pi-fw pi-star',
      items: [
        { label: 'users', icon: 'pi pi-fw pi-user', routerLink: ['/users'], right: 'admin.user.list' },
        { label: 'teams', icon: 'pi pi-fw pi-users', routerLink: ['/teams'], right: 'admin.team.list' },
        { label: 'roles', icon: 'pi pi-fw pi-box', routerLink: ['/roles'], right: 'admin.role.list' },
        { label: 'data-scopes', icon: 'pi pi-fw pi-filter', routerLink: ['/data-scopes'], right: 'admin.datascope.list' },
        { label: 'rights', icon: 'pi pi-fw pi-key', routerLink: ['/rights'], right: 'admin.role.list' },
        { label: 'messageorders', icon: 'pi pi-fw pi-envelope', routerLink: ['/messageorders'], right: 'admin.messageorder.list' },
      ],
    },
    {
      label: 'onlinetests',
      icon: 'pi pi-fw pi-star',
      items: [{ label: 'partners', icon: 'pi pi-fw pi-shield', routerLink: ['/partners'], right: 'admin.partner.list' }],
    },
{
      label: 'toolbox',
      icon: 'pi pi-fw pi-star',
      items: [{ label: 'toolbox-candidates', icon: 'pi pi-fw pi-user', routerLink: ['/toolbox-candidates'], right: 'admin.toolboxcandidate.list' }],
    },
{
        label: 'my_profile',
        items: [
          { label: 'my_profile', icon: 'pi pi-fw pi-user', routerLink: ['/my-profile'] },
          { label: 'availabilities', icon: 'pi pi-fw pi-calendar', routerLink: ['/my-availabilities'] }
        ],
        condition: 'with_availabilities'
      }
];
